import React, { useState } from 'react';
import { trackEvent } from '../../../contexts/userAnalytics';
import './tabToggle.css';

interface TabOption {
    label: string;
    value: string;
    disabled?: boolean;
}

interface TabToggleProps {
    labels?: string[];
    tabOptions?: TabOption[];
    activeTab?: string;
    onChange: (selectedValue: string) => void;
}

const TabToggle: React.FC<TabToggleProps> = ({
    labels,
    tabOptions,
    activeTab,
    onChange,
}) => {
    const resolvedTabOptions = tabOptions || (labels?.map(label => ({ label, value: label, disabled: false })) || []);
    
    const [internalActiveTab, setInternalActiveTab] = useState<string>(resolvedTabOptions[0]?.value || '');
    
    // Use controlled state if provided, otherwise use internal state
    const currentActiveTab = activeTab !== undefined ? activeTab : internalActiveTab;
    
    const handleTabClick = (value: string) => {
        // Update internal state if not controlled
        if (activeTab === undefined) {
            setInternalActiveTab(value);
        }
        onChange(value);
        trackEvent('tab_toggle', { selectedValue: value });
    };

    return (
        <div className="tabToggle-mainContainer">
            {resolvedTabOptions.map((option, index) => {
                const isActive = currentActiveTab === option.value;

                return (
                    <div key={index}>
                        <button
                            className={`tabToggle-tab ${isActive ? 'tabToggle-tab--active' : ''} ${option.disabled ? 'tabToggle-tab--disabled' : ''}`}
                            onClick={() => !option.disabled && handleTabClick(option.value)}
                            title={option.disabled ? 'Coming soon' : undefined}
                        >
                            <label
                                className={`tabToggle-label ${isActive ? 'tabToggle-tab--active' : ''}`}
                            >
                                {option.label}
                            </label>
                        </button>
                        {isActive && (
                            <div className="tabToggle-highlightLine"/>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default TabToggle;